import script from "./ProductReferenceDetail.vue?vue&type=script&setup=true&lang=ts"
export * from "./ProductReferenceDetail.vue?vue&type=script&setup=true&lang=ts"

import "./ProductReferenceDetail.vue?vue&type=style&index=0&id=1f50dcde&scoped=true&lang=scss"

import exportComponent from "C:\\Users\\a-okamura\\Documents\\project\\JuchuAppFront\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1f50dcde"]])

export default __exports__